import {Component, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {ConfirmationService, Message, SelectItem, TreeNode} from 'primeng/api';
import {Route, Router} from '@angular/router';
import {NavService} from '../../_services/_nav.service';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ListaService} from '../../_services/lista.service';
import {ListaItem} from '../../_models/lista-item';
import {MenuVisita} from '../../_models/menu-visita';
import {MenuVisitaService} from '../../_services/menu-visita.service';
import {Funcionalidad} from '../../_models/funcionalidad';

@Component({
  selector: 'app-menu-visita',
  templateUrl: 'menu-visita.component.html'
})
export class MenuVisitaComponent implements OnInit {


  msg: Message;
  /**
   * lista de menús visita
   * @type {Array}
   */
  menusVisitas: MenuVisita[] = [];
  /**
   * menú visita
   * @type {MenuVisita}
   */
  menuVisita: MenuVisita;
  treeProperties: TreeNode[] = [];
  nodeSelected: TreeNode;
  treeselected: TreeNode;
  menu: Funcionalidad = new Funcionalidad();
  tabselected = 1;
  header = this.navService.buscarMensaje('MENUVISITA.LBL_MENU');
  labelPadre: string;
  displayDialog = false;
  submitted = false;
  guardado = false;
  disableHab = true;
  btn: { show: boolean, label: string };
  btnsub: { show: boolean, label: string } = {
    show: false,
    label: ''
  };
  loadingTree = true;
  loadingData = true;
  formulario: FormGroup;

  constructor(private router: Router,
              private location: Location,
              private serMenuVisita: MenuVisitaService,
              private navService: NavService,
              private autServicio: AutenticacionService,
              private confirmationService: ConfirmationService,
              private fb: FormBuilder,
              private serListas: ListaService) {
  }

  ngOnInit() {
    this.btn = {
      show: true,
      label: this.navService.buscarMensaje('MENUVISITA.BTN_AGRMENU')
    };

    const mn = this.autServicio.obtenerFuncionalidades().find(x => x.ruta === 'apl/menu-visita');
    if (mn) {
      this.menu = mn;
    }

    this.formulario = this.fb.group({
      idMenuVisita: [null],
      idPadre: [null],
      nombre: [null, [Validators.required]],
      codigo: [null, [Validators.required]],
      orden: [null],
      indicadorHabilitado: [null, [Validators.required]]
    });

    this.serMenuVisita.listado().subscribe(res => {
      this.menusVisitas = res;
      for (const menu of this.menusVisitas.filter(t => t.idPadre === null )) {
        this.treeProperties.push({
          'label': menu.nombre,
          'data': menu,
          'children': [{
            'label': '+ ' + this.navService.buscarMensaje('LBL_CARGANDO') + '...',
            'data': ''
          }]
        });
      }

      this.new();

      this.loadingTree = false;
      this.loadingData = false;
      this.guardado = false;
    });

  }


  /**
   * volver atras
   */
  goBack(): void {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }


  new() {
    this.submitted = false;
    this.menuVisita = {} as MenuVisita;
    this.tabselected = 1;
    this.menuVisita.indicadorHabilitado = true;
    this.menuVisita.idMenuVisita = null;
    this.menuVisita.codigo = null;
    this.menuVisita.nombre = null;
    this.menuVisita.orden = 1;
    this.menuVisita.idPadre = null;
    this.labelPadre = '';
    this.guardado = false;
    this.disableHab = true;
    this.formatearSub();

  }

  newSub() {

    this.submitted = false;
    this.menuVisita = {} as MenuVisita;
    this.labelPadre = '';
    if (this.nodeSelected.data) {
      this.tabselected = this.tabselected + 1;
      this.menuVisita.idPadre = this.nodeSelected.data.idMenuVisita;
      this.disableHab = true;
    }
    this.guardado = false;
    this.menuVisita.indicadorHabilitado = true;
    this.menuVisita.idMenuVisita = null;
    this.menuVisita.codigo = null;
    this.menuVisita.nombre = null;
    this.menuVisita.orden = 1;
    this.formatearSub();
  }

  formatearSub() {
    this.formulario.reset();
    this.f.indicadorHabilitado.setValue(this.menuVisita.indicadorHabilitado);
    this.f.orden.setValue(this.menuVisita.orden);
    this.f.codigo.setValue(this.menuVisita.codigo);
    this.f.idPadre.setValue(this.menuVisita.idPadre);
    this.f.nombre.setValue(this.menuVisita.nombre);
    this.f.idMenuVisita.setValue(this.menuVisita.idMenuVisita);

  }


  nodeExpand(node: any) {
    let expandChils: any[] = [];
    let chil: any;
    chil = [{'label': '+ ' + this.navService.buscarMensaje('LBL_CARGANDO') + '...',}];

    for (let menu of this.menusVisitas.filter(t => t.idPadre === node.data.idMenuVisita )) {
      expandChils.push({
        'label': menu.nombre,
        'data': menu,
        'parent': node,
        'children': chil
      });
    }
    node.children = expandChils;

  }

  preSelect(node: any) {
    if (this.formulario.dirty) {
      this.confirmationService.confirm({
        message: this.navService.buscarMensaje('MSG_CAMBIAR'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          // this.form.resetForm();
          this.formulario.reset();
          this.nodeSelect(node);

        },
        reject: () => {
          this.nodeSelected = this.treeselected;
        }
      });
    } else {
      this.nodeSelect(node);
    }
  }

  nodeSelect(node: any) {
    this.formulario.reset();
    this.loadingData = true;
    this.guardado = false;
    this.disableHab = false;
    this.treeselected = node;
    this.tabselected = 1;
    this.btnsub.show = true;
    this.btnsub.label = this.navService.buscarMensaje('MENUVISITA.BTN_AGRSUBMENU');


    this.menuVisita = this.menusVisitas.find(t => t.idMenuVisita === node.data.idMenuVisita);
    this.f.idMenuVisita.setValue((this.menuVisita.idMenuVisita !== '' && this.menuVisita.idMenuVisita !== null && this.menuVisita.idMenuVisita !== undefined) ? this.menuVisita.idMenuVisita : null);
    this.f.idPadre.setValue(this.menuVisita.idPadre);
    this.f.nombre.setValue(this.menuVisita.nombre);
    this.f.codigo.setValue(this.menuVisita.codigo);
    this.f.orden.setValue(this.menuVisita.orden);
    this.f.indicadorHabilitado.setValue(this.menuVisita.indicadorHabilitado);

    this.serMenuVisita.obtenerPorId(node.data.idMenuVisita).subscribe(mV => {
      this.menuVisita = mV;
      if (this.menuVisita.indicadorHabilitado === false) {
        this.btnsub.show = false;
      }

      this.loadingData = false;
    });
  }

  guardarCuenta(formulario: any) {
    this.serMenuVisita.crear(formulario).subscribe(data => {
      this.guardado = false;
      let typeMessage = 1; // 1 = Addmessage, this.msg );
      this.navService.setMesage(typeMessage);
      let chil: any[] = [];
      let newChil: any = {
        'label': data.nombre,
        'data': data,
        'children': chil
      };
      this.menusVisitas.push( data );
      if (data.idPadre === null) {
        this.treeProperties.push(newChil);
        this.new();
      } else {
        this.nodeSelected.children.push(newChil);
        this.newSub();
      }

      this.submitted = false;
      this.guardado = false;
    }, error => {
      this.guardado = false;
      let typeMessage = 3; // 1 = Add, 2 = Update, 3 = Error, 4 Custom
      this.navService.setMesage(typeMessage);
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      const formulario = this.formulario.getRawValue();
      if (this.menuVisita.idMenuVisita === null ||
        this.menuVisita.idMenuVisita === '' ||
        this.menuVisita.idMenuVisita === undefined) {
        /** Crear cuenta contable */
        this.guardado = true;
        const menuVis = this.menusVisitas.find(x => x.codigo == this.f.codigo.value);
        if (menuVis) {
          /** Existe codigo del menú visita */
          this.guardado = false;
          this.navService.setMesage(0, {
            severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
            detail: this.navService.buscarMensaje('MENUVISITA.MSG_ERRORCODIGO')
          });
        } else {
          /** Crear cuenta contable */
          this.guardarCuenta(formulario);

        }
      } else {
        /** Actualizar cuenta contable */
        this.guardado = true;
        this.serMenuVisita.actualizar(formulario).subscribe(menuVisitaActualizado => {
          this.guardado = false;
          let typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
          this.navService.setMesage(typeMessage, this.msg);
          this.nodeSelected.label = formulario.nombre;
          for (let i = 0; i < this.menusVisitas.length; i++) {
            if (this.menusVisitas[i].idMenuVisita === formulario.idMenuVisita) {
              this.menusVisitas[i] = menuVisitaActualizado;
            }
          }
          if (menuVisitaActualizado.indicadorHabilitado === false) {
            this.serMenuVisita.listado().subscribe(res => {
              this.menusVisitas = res;
            });
          }
          this.submitted = false;
          this.guardado = false;
          this.menuVisita = menuVisitaActualizado;
          this.formatearSub();
        }, error => {
          this.guardado = false;
          let typeMessage = 3; // 1 = Add, 2 = Update, 3 = Error, 4 Custom
          this.navService.setMesage(typeMessage);
        });
      }
    }
  }


  doCancel(fDirty: boolean) {

    if (fDirty) {
      this.confirmationService.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          // this.form.resetForm();
          this.loadingData = true;
          if (this.menuVisita.idMenuVisita === null || this.menuVisita.idMenuVisita === '' || this.menuVisita.idMenuVisita === undefined) {
            if (this.menuVisita.idPadre === null) {
              this.new();
            } else {
              this.newSub();
            }
            this.loadingData = false;
          } else {
            this.serMenuVisita.obtenerPorId(this.menuVisita.idMenuVisita).subscribe(res => {
              this.menuVisita = res;
              this.loadingData = false;
            });
          }
          this.formulario.reset();
          this.formatearSub();
        }
      });
    } else {
      this.msg = {
        severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION') + '!',
        detail: this.navService.buscarMensaje('MSG_NOHAYCAMBIOSDESCARTAR')
      };
      this.navService.setMesage(4, this.msg);
    }
  }


}
